// useGetList returns 25 records by default - pre-filter dropdowns need every option.
export const ALL_OPTIONS = { pagination: { page: 1, perPage: 1000 } };
